import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { Mic2, ArrowRight, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useStore } from '../../data/store';

function isDeadlinePassed(deadline) {
  if (!deadline) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(deadline + 'T00:00:00') < today;
}

export default function BandApplicationTeaser() {
  const [ref, isVisible] = useScrollAnimation();
  const event = useStore((s) => s.event);
  const closed = isDeadlinePassed(event?.applicationsDeadline);

  return (
    <section id="bewerben" className="bg-bg-primary section-padding">
      <div
        ref={ref}
        className={`max-w-3xl mx-auto transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="bg-bg-card border border-divider p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className={`shrink-0 w-16 h-16 flex items-center justify-center ${closed ? 'bg-white/5' : 'bg-accent-red/10'}`}>
            {closed ? (
              <Lock size={36} className="text-text-muted" />
            ) : (
              <Mic2 size={36} className="text-accent-red" />
            )}
          </div>

          <div className="flex-1 text-center md:text-left">
            <p className={`font-heading text-xs tracking-[4px] mb-2 ${closed ? 'text-text-muted' : 'text-accent-red'}`}>
              FÜR BANDS & KÜNSTLER
            </p>
            <h2 className="font-heading text-text-primary mb-3" style={{ fontSize: 'clamp(22px, 4vw, 32px)' }}>
              {closed ? 'BEWERBUNGSPHASE BEENDET' : 'IHR WOLLT 2026 SPIELEN?'}
            </h2>
            <p className="font-body text-text-muted text-base leading-relaxed max-w-lg">
              {closed
                ? (event?.applicationClosedText || 'Die Bewerbungsphase ist abgeschlossen. Vielen Dank an alle Bands, die sich beworben haben!')
                : (event?.applicationOpenText || 'Rock\'n\'Rhein lebt von aufstrebenden Bands, die Bock haben alles zu geben. Bewerbt euch jetzt für einen Slot auf unserer Bühne.')}
            </p>
          </div>

          {!closed && (
            <div className="shrink-0">
              <Link
                to="/bewerben"
                className="inline-flex items-center gap-2 bg-accent-red text-white font-heading tracking-wider text-sm px-7 py-3.5 border-2 border-accent-red hover:bg-transparent hover:text-accent-red transition-all min-h-[48px] whitespace-nowrap"
              >
                ZUR BEWERBUNG
                <ArrowRight size={16} />
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
